var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QImage2',{attrs:{"relativePath":_vm.relativePath,"size":_vm.size,"fallbackIcon":'mdi-package-variant-closed'}})
}
var staticRenderFns = []

export { render, staticRenderFns }